import type { MonitorInterface, MonitorReporter } from '@zg-rentals/monitor-base';
import { BaseMonitor, MonitorPlugin } from '@zg-rentals/monitor-base';

export abstract class BrowserMonitorPlugin extends MonitorPlugin {
  abstract onLoad?(e: Event): void;
  abstract onUnload?(e: Event): void;
}

export class BrowserMonitor extends BaseMonitor<BrowserMonitorPlugin, MonitorReporter> {
  constructor(args: MonitorInterface<BrowserMonitorPlugin, MonitorReporter> = {}) {
    super(args);
  }
}
